export const AWAIT_RESTART = 'AWAIT_RESTART';
export const AWAIT_RESTART_SUCCESS = 'AWAIT_RESTART_SUCCESS';
export const AWAIT_RESTART_ERROR = 'AWAIT_RESTART_ERROR';
export const AWAIT_RESTART_TIMEOUT = 'AWAIT_RESTART_TIMEOUT';
export const TRIGGER_RESTART = 'TRIGGER_RESTART';

// Cause the server to restart
export const triggerRestart = () => ({ type: TRIGGER_RESTART });

// Wait for a restart to complete
export const awaitRestart = (payload) => ({
	type: AWAIT_RESTART,
	payload: {
		// Time to wait before doing anything
		initialDelay: 500,
		// Interval to ping the server
		checkInterval: 500,
		// Time after the initial delay to trigger a timeout error
		timeout: 59500,
		// Show the restarting dialog or disable to just keep state
		showDialog: true,
		...payload
	}
});
